import React from 'react'

const SICargoUploadContext = React.createContext()

export default SICargoUploadContext
